module.exports = __webpack_public_path__ + "static/media/em-10.15faa34a.png";